import React, { useEffect } from 'react';
import { FormControl, FormHelperText, FormLabel, Grid } from '@material-ui/core';
import { useStyles } from '../../styles';
import { useStateMachine } from 'little-state-machine';
import { Controller, useForm } from 'react-hook-form';
import { Button, Fade, FormControlLabel, FormGroup, Radio, RadioGroup } from '@mui/material';
import { IFormStep } from '../pilotGroupAssessment.interface';
import { updateAction } from '../pilotGroupactions';

export const Section4: React.FC<IFormStep> = ({ step, setStep }) => {
  const { state, actions } = useStateMachine({
    updateAction
  });
  const {
    handleSubmit,
    getValues,
    control,
    formState: { errors }
  } = useForm({
    defaultValues: state.pilotGroupAssessment.formData as any
  });
  const classes = useStyles();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleBack = () => {
    const partialData = getValues();
    actions.updateAction({ pilotGroupAssessment: { formData: partialData } } as any);
    setStep(step - 1);
  };

  const onSubmit = (data: any) => {
    console.log('onSubmit Step 4: ', data);
    actions.updateAction({ pilotGroupAssessment: { formData: data } } as any);
    setStep(step + 1);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Fade in={true}>
        <Grid className={classes.formContent} container spacing={5} alignItems="center" justifyContent="center">
          <Grid container item xs={12} direction="column">
            <FormControl>
              <FormLabel className={classes.formLabel}>Did you find any value in this short program? *</FormLabel>
              <Controller
                render={({ field }) => (
                  <RadioGroup style={{ marginLeft: 50 }} {...field}>
                    {['Yes', 'No'].map((option, index) => (
                      <FormControlLabel
                        key={index}
                        value={option}
                        control={<Radio style={{ marginRight: 10 }} color="success" />}
                        label={option}
                        style={{ marginBottom: 8, scale: '110%' }}
                      />
                    ))}
                  </RadioGroup>
                )}
                name="programValue"
                control={control}
                rules={{ required: true }}
              />
              {errors?.programValue?.type === 'required' && (
                <FormHelperText style={{ color: 'red', fontWeight: 'bold' }}>Required</FormHelperText>
              )}
            </FormControl>
          </Grid>

          <Grid item className={classes.buttonContainter}>
            <Button className={classes.button} variant="outlined" color="success" onClick={() => handleBack()}>
              BACK
            </Button>
          </Grid>

          <Grid item className={classes.buttonContainter}>
            <Button className={classes.button} variant="contained" color="success" type="submit">
              NEXT
            </Button>
          </Grid>
        </Grid>
      </Fade>
    </form>
  );
};
